"use strict";

import {gh} from './general-helpers';
import {Tooltip} from 'bootstrap';
import {gsap} from 'gsap';
import { CustomEase } from "gsap/CustomEase";

(function( $ ) {
	// Only for .general class page (new design)
	if ( $( gh.html ).hasClass( 'general' ) ) {

		/* Read progress bar
		-------------------------------------------------------------------*/
		const  mainTag = document.getElementById('site-content'),
		       // siteFooter = document.getElementById('site-footer'),
		       progressBar = document.getElementById( 'reading-progress-bar' )
		let readProgressScroll = () => {
			let docElem       = document.documentElement,
			    scrollTop     = mainTag.scrollTop || docElem.scrollTop,
			    scrollBottom  = (mainTag.scrollHeight || docElem.scrollHeight) - window.innerHeight,
			    scrollPercent = (- 100 + (scrollTop / scrollBottom * 100));
			    scrollPercent = scrollPercent <= 0 ? scrollPercent : '0';
				progressBar.style.setProperty( '--scrollAmount', scrollPercent + '%' );
		} // FNC

		// INIT readProgressScroll
		if ( progressBar ) {
			readProgressScroll();

			gh.doOnEvent( {
				scroll: 20,
				resize: 120,
				orientationchange: null, // on window orientationchange (for older browsers)
			}, readProgressScroll );
		} // IF


		/* Menu bottom panel
		-------------------------------------------------------------------*/
		function mobileMenuIsActive( is_active ) {
			const action = is_active ? 'remove' : 'add';

			mainMenuBtn.firstElementChild.classList[action]( 'active' );

			if (window.matchMedia( '(max-width: 1199px)' ).matches) {
				gh.html.classList[action]( 'overflow-hidden' );
				gh.body.classList[action]( 'overflow-hidden' );
			}
		}

		const mainMenuBtn = document.getElementById( 'main-menu-btn' );
		if (mainMenuBtn) {
			// activate menu on click
			mainMenuBtn.addEventListener( 'click', function() {
				if ( mainMenuBtn.firstElementChild.classList.contains( 'active' ) ) {
					mobileMenuIsActive( true ); // deactivate
				} else {
					mobileMenuIsActive( false ); // activate
				}
				document.getElementById( 'menu-bottom-panel' ).classList.toggle( 'active' );
			} );


			// close menu on click at <a> tag or #site-content (<main>)
			$( document ).on( 'click', '#site-content, a', function(event) {

				// if menu-extra-links don't close the menu
				if (event.target.nodeName.toLowerCase() === 'a'
					&& event.target.classList.contains( 'menu-extra-links__link' )) return;

				document.getElementById( 'menu-bottom-panel' ).classList.remove( 'active' );
				mobileMenuIsActive( true ); // deactivate it
			} );
		} // IF


		/* Show menu bar shadow only on scroll
		-------------------------------------------------------------------*/
		const mainNavbar = document.getElementById( 'main-navbar' );
		function menuBarShadowOnScroll() {
			if ( gh.html.scrollTop > 10 ) {
				mainNavbar.classList.add( '--shadow' );
			} else {
				mainNavbar.classList.remove( '--shadow' );
			}
		} // FNC

		gh.doOnEvent( {
			load: null,
			scroll: 50,
		}, menuBarShadowOnScroll );


		/* Change placeholder of subscribe form in the header menu
		-------------------------------------------------------------------*/
		document.addEventListener( 'yadroCf7AjaxLoaded', () => {
			mainNavbar.querySelectorAll( '.wpcf7-email' ).forEach( (elem) => {
				elem.setAttribute( 'placeholder', 'Подпишись на рассылку' );
			} );
		} );

		/* Header Search
		-------------------------------------------------------------------*/
		// show search panel (animation)
		let searchTimeLine;
		$( mainNavbar ).on( 'click', '#search-bar-btn', function(e) {

			// init timeline
			searchTimeLine   = gsap.timeline({ paused: true } );

			// special easing from the Apple site example
			CustomEase.create('search-start', "0.2727, 0.0986, 0.8333, 1");
			CustomEase.create('search-form-items', "0.25, 0.1, 0.25, 1");

			if ( gh.isDesktopDesign ) {
				// animating search icon and menu items
				searchTimeLine.to( [this.parentElement.querySelectorAll('.nav-item'), this], {
					autoAlpha: 0,
					scale:   0,
					duration: 0.35,
					ease: 'search-start',
					stagger: { // wrap advanced options in an object
						each: 0.07,
						from: 'end',
					},
				} );
			} else {
				searchTimeLine.to( this, { autoAlpha: 0, scale:   0, duration: 0.35, ease: 'search-start' } );
			}

			// animating search form
			searchTimeLine.to( mainNavbar.querySelector( '.header-search-wrap' ), { autoAlpha: 1, duration: 0.1, ease: 'none' }, (gh.isDesktopDesign ? '-=0.2' : '-=0.2') );
			// search icon
			searchTimeLine.fromTo( mainNavbar.querySelector('label[for="header-search-submit"]'), { x: 100 }, {x: 0, duration: 0.3, ease: 'search-form-items'} ,'-=0.3' );
			searchTimeLine.to( mainNavbar.querySelector('label[for="header-search-submit"]'), { autoAlpha: 1, duration: 0.3, ease: 'power2.in' },'-=0.3' );
			// input field
			searchTimeLine.fromTo( mainNavbar.querySelector('.header-search__input'), { x: 100 }, { x: 0, duration: 0.3,	ease: 'search-form-items' }, '-=0.2' );
			searchTimeLine.to( mainNavbar.querySelector('.header-search__input'), { autoAlpha: 1,duration: 0.3, ease: 'power2.in' },'-=0.3' );

			if (gh.isDesktopDesign) {
				// show bottom border
				searchTimeLine.add( () => {
					mainNavbar.querySelector('.header-search__input').classList.add('shown')
				}, '<25%' );
			}

			// focus input field after animation
			searchTimeLine.add( () => {
				mainNavbar.querySelector( '.header-search__input' ).focus();
			}, '+=0.2' );

			searchTimeLine.play();
		} ); // CLICK

		// close search panel (animation)
		$( mainNavbar ).on( 'click', '.header-search__clear', function(e) {

			if (gh.isMobileDevice) {
				searchTimeLine.reverse(2);
			} else {
				searchTimeLine.reverse();
			}

			// hide notice tooltip if it's present (that input field is empty)
			const searchIcon = this.parentElement.querySelector( '.search-icon-wrap' );
			if ( searchIcon.eyTooltipInstance) {
				searchIcon.eyTooltipInstance.hide();
			}
		} );

		/* General Search
		-------------------------------------------------------------------*/
		// clear search field on close icon click and close search panel
		$( gh.body ).on( 'click', '.general-search-form__clear', function() {
			this.parentElement.querySelector( '.general-search-form__input' ).value = '';
		} );


		// init Search Notice tooltips
		document.querySelectorAll( '.search-tooltip' ).forEach( el => {
			// tooltipHandler( el, {
			// 	sanitize: false,
			// } )

			const t = new Tooltip( el, {
				sanitize:    false,
				placement:   'bottom',
				trigger:     'manual',
				html:        true,
				customClass: 'search-notice-tooltip pe-none',
			} );

			// hide tooltips when there is something in the form input
			const searchForm = $( el ).parents( 'form' );
			searchForm.find('.general-search-form__input').on( 'input', function() {
				if (this.value) {
					const searchIcon = searchForm[ 0 ].querySelector( '.search-icon-wrap' );
					if ( searchIcon.eyTooltipInstance) {
						searchIcon.eyTooltipInstance.hide();
					}
				}
			} );
		} );

		// show tooltip when user is trying to submit empty search form
		document.addEventListener('invalid', (function () {
			return function (e) {
				if ( e?.target.classList.contains('general-search-form__input') ) {

					if (! e.target.value ) {
						const searchIcon = e.target.parentElement.querySelector( '.search-icon-wrap' );
						searchIcon.eyTooltipInstance = Tooltip.getInstance( searchIcon )
						searchIcon.eyTooltipInstance.show();
						// setTimeout( function() {
						// 	Tooltip.getInstance( searchIcon ).hide();
						// }, 5000 );
					}

					// to prevent default browser's tooltip
					e.preventDefault();
					e.target.focus();
				}
			};
		})(), true);


		/* Category Slider & Category filter
		-------------------------------------------------------------------*/
		// if (typeof yeCategoryFilter !== 'undefined') {
			$( window ).on( 'load', function() {
				const categorySlider = $( '#category-slider' );
				if ( ! categorySlider.length ) return;

				// init the slider
				gh.rowNavSliderInit( categorySlider );
			} );
		// } // IF

		/* Most popular articles | Aside
		-------------------------------------------------------------------*/
		function initPopularArticlesSlider( selector ) {
			selector.owlCarousel( {
				margin:     0,
				dots:       true,
				nav:        true,
				loop:       true,
				autoHeight: true,
				items:      1,
				navContainerClass: 'owl-nav spacer-mt-10',
				navText:    [
					gh.owlSliderCustomNavArrows( 'mobile', true, 'color-accent', false ),
					gh.owlSliderCustomNavArrows( 'mobile', false, 'color-accent', false ),
				],
				smartSpeed: 500,
			} );
		} // FNC
		initPopularArticlesSlider( $( '.popular-posts-slider' ) );
		document.addEventListener( 'yePostsContainerCleared', () => {
			initPopularArticlesSlider( $( '.popular-posts-slider' ) );
		} );

		/* Underline links functionality
		-------------------------------------------------------------------*/
		// Hover
		if ( ! gh.isMobileDevice ) {
			$( document ).on( 'mouseenter', '.accent-underline.--anim', function() {
				gh.animAccentUnderline( this );
			} );
			$( document ).on( 'mouseleave', '.accent-underline.--anim', function() {
				if( ! this.classList.contains('--freeze') ) {
					this.yeAnimTimeLine?.reverse()
				}
			} );
		} // IF

		/* Text tooltips
		-------------------------------------------------------------------*/
		function tooltipHandler(el, extraConfig) {
			let tooltipClass = 'text-tooltip-show';

			// add extra classes
			let extraClass = el.getAttribute( 'data-extra-class' );
			tooltipClass += extraClass ? ' ' + extraClass : '';

			let tooltipConfig = {
				placement:   'bottom',
				trigger:     'manual',
				html:        true,
				customClass: tooltipClass,
				// sanitize: false
			};

			// add extra config settings
			if (extraConfig) {
				tooltipConfig = {...tooltipConfig, ...extraConfig};
			}

			const tooltip = new Tooltip( el, tooltipConfig );

			let delay        = 300,
				timerEnterId = null,
				timerLeaveId = null

			$( el )
				.on( 'mouseenter', function() {
					if ( timerLeaveId ) {
						clearTimeout( timerLeaveId )
					}

					timerEnterId = setTimeout( function() {
						tooltip.show()

						$( '[role="tooltip"]' )
							.on( 'mouseenter', function() {
								clearTimeout( timerLeaveId )
							} )
							.on( 'mouseleave', function() {
								setTimeout( function() {
									tooltip.hide()
								}, delay )
							} )
					}, delay )
				} )
				.on( 'mouseleave', function() {
					if ( timerEnterId ) {
						clearTimeout( timerEnterId )
					}

					timerLeaveId = setTimeout( function() {
						tooltip.hide()
					}, delay )
				} )

			el.dataset.handlerAdded = true;
		}

		const textTooltipList = document.querySelectorAll( '.text-tooltip' )
		if ( textTooltipList ) {
			textTooltipList.forEach( el => {
				tooltipHandler(el)
			} )
		} // IF | Text Tooltips

		document.addEventListener( 'yadroAjaxPostsLoaded', () => {
			let tooltips = document.querySelectorAll( '.text-tooltip' )
			if ( tooltips ) {
				tooltips.forEach(el => {
					if (!el.dataset.handlerAdded) {
						tooltipHandler(el)
					}
				})
			}
		})

		/* Load More Posts functionality for certain listing pages
		-------------------------------------------------------------------*/
		if (typeof yePostListingPage !== 'undefined') {
			gh.initLoadMorePostsListingPage();
		}

		/* Content filter functionality ( by category or post type)
		** for Search, Archive and some other listing pages
		-------------------------------------------------------------------*/
		if (typeof yeContentFilter !== 'undefined') {
			const contentFilterElem = document.getElementById( 'content-filter' );

			// init content filter
			gh.initListingContentFilter( contentFilterElem );

			// for Post Type filter
			// make inactive tabs/links for certain post types on Search/Archive page
			// if the found posts don't include these post types
			if ( yeContentFilter.foundPostTypes ) {
				for ( const type in yeContentFilter.foundPostTypes ) {
					if (! yeContentFilter.foundPostTypes[type]) {
						// contentFilterElem.querySelector( `[data-type="${type}"]` ).classList.add('pe-none', 'user-select-none', 'opacity-50');
						// hide tabs/link
						contentFilterElem.querySelector( `[data-type="${type}"]` ).classList.add('d-none');
					}
				}
			}
		} // IF


		/* Set width for the site line headings (red lines)
		-------------------------------------------------------------------*/
		function setLineHeadingLineWidth() {
			document.querySelectorAll( '.line-heading__title' ).forEach( (elem, i) => {

				if (elem.closest('.line-heading').classList.contains( '--fixed-width' )) return;

				if (! gh.isDesktopDesign) {
					if (elem.closest('.line-heading').classList.contains( '--fixed-mobile-width' )) return;
				}

				if ( elem.parentElement.classList.contains( '--reverted' ) ) {
					gsap.to( elem, { '--line-width-r':
							Math.ceil( elem.getBoundingClientRect().left + elem.clientWidth ) + 'px'
						, duration: 0.3, ease: "power1.out" } );
				} else {
					gsap.to( elem, { '--line-width':
							Math.ceil((document.body.clientWidth - elem.getBoundingClientRect().right) + elem.clientWidth)  + 'px'
						, duration: 0.3, ease: "power1.out" } );
				} // IF
			} ); // EACH
		} // FNC

		gh.doOnEvent( {
			load:              null,
			resize:            100,
			orientationchange: null, // on window orientationchange (for older browsers)
		}, setLineHeadingLineWidth );

		/* Forms
		-------------------------------------------------------------------*/
		document.addEventListener( 'yadroCf7AjaxLoaded', () => {
			// For checkbox design to work
			$( '.std-form-wrap' ).on( 'click', 'input[type=checkbox]', function( event ) {

				// if target is a link
				if ( 'a' === event.target.nodeName.toLocaleLowerCase() ) {
					return;
				}

				this.parentElement.classList.toggle( 'checked' ); // our fancy checkmark design add to label tag
				// this.querySelector('input').checked ^= 1; // toggle checkbox | because of preventDefault()
			} );

			/* Check acceptance checkboxes in CF7 form
			-------------------------------------------------------------------*/
			// document.querySelectorAll( '.wpcf7-acceptance' ).forEach( ( elem ) => {
			// 	elem.querySelector( 'label' ).click()
			// } );


			$( '.short-form-wrap' ).on( 'click', 'input[type=checkbox]', function( event ) {

				// if target is a link
				if ( 'a' === event.target.nodeName.toLocaleLowerCase() ) {
					return;
				}

				this.parentElement.classList.toggle( 'checked' ); 
			} );

		} ); // ON | yadroCf7AjaxLoaded

		/* Prevent form submisson in CF7 forms if required fields are empty (frontend validation)
		-------------------------------------------------------------------*/
		gh.initCF7FrontendValidation();

		/* Hide meta tooltips on the site if they don't overlay the meta text
		-------------------------------------------------------------------*/
		gh.doOnEvent( {
			load:              null,
			resize:            300,
			orientationchange: null, // on window orientationchange (for older browsers)
		}, gh.hideMetaTooltip );

		document.addEventListener( 'yadroAjaxPostsLoaded', gh.hideMetaTooltip );


		/* Random banner
		-------------------------------------------------------------------*/
		function pickBanner() {
			let bannersPlaces = document.querySelectorAll('.widget_rnd_linked_banner_widget:not(.js-done)');
			bannersPlaces.forEach(bannersPlace => {
				let linkedBanners = bannersPlace.querySelectorAll('a');
				if (linkedBanners.length) {

					// to run the function one time per widget
					if (linkedBanners[0].parentElement.yeWidgetIsInited) return;

					let bannerToShow = linkedBanners[Math.floor(Math.random() * linkedBanners.length)];
					linkedBanners.forEach(banner => {
						if (banner !== bannerToShow) {
							banner.style.display = 'none';
						} else {
							banner.style.display = '';
						}
					});
					linkedBanners[0].parentElement.yeWidgetIsInited = true;
				} // IF
				bannersPlace.classList.add('js-done');
			})
		}

		function createNodes(htmlString) {
			let div = document.createElement('div');
			div.innerHTML = htmlString.trim();

			return div.firstChild;
		}

        function populateBanners(bannersPlaceholders, widgets) {
            bannersPlaceholders.forEach(bannersPlaceholder => {
                widgets.forEach(widget => {
                    if (widget?.rendered) {
                        bannersPlaceholder.after(createNodes(widget.rendered));
                    }
                })
                bannersPlaceholder.remove();
            })
        }

        // TODO Rework to add one banner instead of the whole widget
        function fetchWidgets() {
            let bannersPlaceholders = document.querySelectorAll('.js-sidebar-frontpage-placeholder');
            if (!bannersPlaceholders) {
                return;
            }

            let widgets = '';
            let widgetsJson = '';
            let widgetsDate = '';

            try {
                widgetsJson = localStorage.getItem("yadroWidgets");
                widgetsDate = localStorage.getItem("yadroWidgetsDate");
            } catch (e) {
            }

            let currentDate = frontendData?.widgetsDate || Math.floor(Date.now() / 1000) - 60 * 60 * 24;
            let widgetsRest = frontendData?.widgetsRest || '';
            if (!widgetsRest) {
                return;
            }

            if (widgetsJson && widgetsDate && (parseInt(widgetsDate) >= parseInt(currentDate))) {
                widgets = JSON.parse(widgetsJson);
                populateBanners(bannersPlaceholders, widgets);
                pickBanner();
            } else {
                fetch(widgetsRest, {
                    method: 'GET'
                })
                    .then(res => res.json())
                    .then(response => {
                        try {
                            localStorage.setItem('yadroWidgets', JSON.stringify(response));
                            localStorage.setItem('yadroWidgetsDate', currentDate);
                        } catch (e) {
                        }
                        populateBanners(bannersPlaceholders, response);
                    })
                    .then(() => {
                        pickBanner();
                    })
                    .catch(error => {
                        // Do nothing
                    });
            }
        }

		['DOMContentLoaded', 'yadroAjaxPostsLoaded'].forEach( eventName => {
			document.addEventListener( eventName, () => {
				pickBanner();
                fetchWidgets();
			} );
		} ); // ON EVENTS :


	} // IF this page | general
})( jQuery );